"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollPosition = void 0;
var react_1 = require("react");
function getPosition() {
    return {
        scrollX: window.scrollX,
        scrollY: window.scrollY,
    };
}
function useScrollPosition() {
    var _a = react_1.useState(getPosition()), position = _a[0], setPosition = _a[1];
    react_1.useEffect(function () {
        function handleScroll() {
            setPosition(getPosition());
        }
        document.addEventListener('scroll', handleScroll);
        return function () {
            document.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return position;
}
exports.useScrollPosition = useScrollPosition;
//# sourceMappingURL=useScrollPosition.js.map